<template>
  <div
    v-if="totalResultCount > 0"
    class="ResultStats"
  >
    <p class="ResultStats-stat">
      {{ format(paginationResultsCount.from) }} - {{ format(paginationResultsCount.to) }} of {{ format(totalResultCount) }} results
    </p>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
    };
  },
  computed: {
    ...mapState('search', {
      results: (state) => state.results.length,
      totalResultCount: (state) => state.resultCount,
      paginationResultsCount: (state) => state.pagination.showing,
    }),
  },
  methods: {
    format(value) {
      return value.toLocaleString();
    },
  },
};
</script>

<style lang="scss" scoped>
 @import "../../../../scss/abstracts/abstracts";

  .ResultStats{
    padding-left: spacing();
    padding-right: spacing();
     margin-top: 1rem;
   //@include respond-to(md){
   //}
  }
</style>
